import { useCallback, useSyncExternalStore } from "react";

function subscribe(callback: () => void) {
  window.addEventListener("hashchange", callback);
  window.addEventListener("popstate", callback);
  return () => { window.removeEventListener("hashchange", callback); window.removeEventListener("popstate", callback); };
}

export function useUrlState(key: string, initial: string) {
  const hash = useSyncExternalStore(subscribe, () => window.location.hash, () => "");
  const value = new URLSearchParams(hash.slice(1)).get(key) ?? initial;
  const set = useCallback((next: string, push = false) => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    if (next === initial) params.delete(key); else params.set(key, next);
    const target = `${window.location.pathname}${window.location.search}${params.size ? `#${params}` : ""}`;
    if (push) window.history.pushState(null, "", target); else window.history.replaceState(null, "", target);
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  }, [key, initial]);
  return [value, set] as const;
}
